import { JiraServiceManagementIcon } from '@atlaskit/logo';

import { Journeys } from '@atlassiansox/cross-flow-support/cross-flow-api-internals';

import { Targets } from '@atlassiansox/cross-flow-support/cross-flow-base-types';

import {
	AtlasSideNavAppRecommendationMenuItem,
	type ComponentProps,
} from '@post-office/browser--growth/components/atlas-side-nav-growth-item';

import { type JSX } from 'react/jsx-runtime';

const ProductLogo = () => <JiraServiceManagementIcon size="xsmall" appearance="brand" />;

export const AtlasSideNavRecommendationJsm = ({ ...props }: ComponentProps): JSX.Element => {
	return (
		<AtlasSideNavAppRecommendationMenuItem
			{...props}
			appName={'Jira Service Management'}
			logo={<ProductLogo />}
			targetProduct={Targets.JIRA_SERVICE_DESK}
			journeyType={Journeys.DECIDE}
		/>
	);
};
